module.exports = "../images/boat-2@2x.jpg?v=616a52f";